import styled from 'styled-components/macro';
import {useState} from "react";
import {useFeedback} from "../store/feedback";
import {useCreateComment} from "../api/comment";
import Button from "./button";
import MarkdownField from "./markdown_field";
import ErrorMessage from "./error_message";
import Spinner from "./spinner";
import {themecolors} from "../utils/themecolors";

const Save = styled.div``;

const CreateComment = styled(({className, comment, onCreated, onClose}) => {
    const creating = useFeedback();
    const [content, setContent] = useState('');
    const [posting, setPosting] = useState(false);
    const createComment = useCreateComment(creating.channel);
    const handleCreate = async () => {
        if (posting) return;
        const {community} = comment;
        const parentId = comment.parent_id;
        try {
            setPosting(true);
            const newComment = await createComment(community, parentId, comment ? comment.id : 0, content);
            if (typeof onCreated === 'function') {
                onCreated(newComment);
            }
            onClose();
        } catch {
            // error is displayed
        }
        setPosting(false);
    };
    return (
        <div className={className}>
            <MarkdownField
                id='content' placeholder="Add your comment" minRows={5}
                value={content} onChange={setContent} autofocus
            />
            <Save>
                <ErrorMessage error={creating.error}/>
                {creating.busy && <Spinner/>}
                <Button onClick={onClose} disabled={creating.busy} tabindex={-1}>Cancel</Button>
                <Button onClick={handleCreate} disabled={creating.busy}>Save</Button>
            </Save>
        </div>
    )
})`
  margin-top: 8px;
  max-width: 464px;
  
  ${Save} {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
    font-size: 14px;
  }
  ${Save} button {
    margin-left: 12px;
    padding: 8px 16px;
    border-radius: 48px;
    ${({theme}) => `
        color: ${theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
        background-color: ${theme.color.name === 'dark' ? theme.dark_border : '#ececec'};
    `}
  }
  ${Save} button:first-of-type {
    background-color: transparent;
    border: none;
    padding: 8px 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text: themecolors.light_low_impact_text};
  }
  
  @media only screen and (max-width: 780px) {
    & {
      margin-left: 0;
      width: 100%;
    }
  }
`;

export default CreateComment;
